module.exports = __webpack_public_path__ + "img/img7.4a3c5672.png";